import { useMe } from '@/features/settings/hooks/useMe'
import { useCurrentOrganization } from '@/features/organization/hooks/useCurrentOrganization'

/**
 * True only for the organization owner or the protected admin role. Org-wide
 * scope alone is not administrative (for example Auditor and Accountant).
 *
 * Used to gate org-admin-only surfaces such as company credentials, which must
 * never be visible to staff or company managers. All data comes from
 * GET /users/me; no other frontend role logic.
 */
export function useIsOrgAdmin(): boolean {
  const { data: me } = useMe()
  const { data: organization } = useCurrentOrganization()
  if (!me || typeof me.roleId === 'string') return false
  return me.roleId.slug === 'admin' || organization?.createdBy === me._id
}
